<template>
    <div id="staff_manage">
        <div v-if="tabshow">
            <v-class></v-class>
        </div>
        <v-reading
            :showflag.sync="readingflag"
            @hidden="closecharge"
        ></v-reading>
    </div>
</template>

<script>
import Reading from "./children/Reading";
import Chooseclass from "./children/chooseclass";

export default {
    name: "Staff",
    components: {
        "v-reading": Reading,
        "v-class": Chooseclass,
    },
    data() {
        return {
            readingflag: true,
            tabshow: false,
            activeName: "chooseclass",
            tabIndex: "0",
        };
    },
    created() {
        let agree = window.sessionStorage.getItem("isagree");
        if (agree == "false") {
            this.readingflag = false;
            this.tabshow = true;
        } else {
            this.readingflag = true;
        }
        this.$global.activeMenu = "2-2";
    },
    methods: {
        closecharge(flag) {
            let me = this;
            me.readingflag = flag;
            me.tabshow = !flag;
        },
        setIndex(e) {
            this.tabIndex = e.index;
        },
    },
};
</script>
<style lang="scss">
#staff_manage {
    .el-form-item__label {
        font-size: 16px;
    }
    .formarea {
        border: 1px solid #e6eaef;
        margin: 20px 0;
        padding: 0 10px;
        .el-row {
            border-bottom: 1px dashed #e6eaef;
            .el-form-item {
                margin: 0px;
            }
        }
        .el-radio-button__inner {
            font-size: 16px;
            border: none !important;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            color: #409eff;
            background-color: #fff;
            box-shadow: none;
        }
    }

    .chooseClass {
        margin-bottom: 20px;
        .c-title {
            display: flex;
            margin-bottom: 10px;
            div {
                font-size: 16px;
                height: 30px;
                line-height: 30px;
            }
            .b {
                background: #0089e5;
                height: 30px;
                display: inline-block;
                width: 3px;
                margin-right: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue